<template>
    <div>
        <hr class="mt-3 mb-2" />
        <p class="mb-2 text-uppercase force-secondary">Formes juridiques</p>
        <b-form-group class="mb-2">
            <b-form-checkbox-group
                v-model="selected"
                :options="legalFormOptions"
                class="force-white"
                switches
                stacked
                @change="wait"
            ></b-form-checkbox-group>
        </b-form-group>
        <div class="row">
            <div class="col-6 pr-1">
                <b-button
                    variant="secondary"
                    size="sm"
                    class="btn-block mt-0"
                    @click="setAll"
                >
                    Toutes
                </b-button>
            </div>
            <div class="col-6 pl-1">
                <b-button
                    variant="secondary"
                    size="sm"
                    class="btn-block mt-0"
                    @click="setNone"
                >
                    Aucune
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater'

export default {
    name: 'LegalFormFilter',

    mixins: [DataUpdater],

    data() {
        return {
            selected: null,
            form: {},
        }
    },

    async mounted() {
        await this.filters
        this.selected = this.filters.legalForms
        if (this.selected.length === 0) {
            this.setAll()
        }
    },

    methods: {
        wait() {
            setTimeout(this.setFilter, 500)
        },

        async setFilter() {
            this.form.selected = this.selected
            this.$store.commit(
                'reportingVM/SET_LEGAL_FORM_FILTER',
                this.selected
            )
            await this.$store.dispatch(
                'reportingVM/setLegalFormFilter',
                this.form
            )
            this.updateData()
            await this.$store.dispatch('reportingVM/refreshCounters')
        },

        setAll() {
            const selected = []
            this.legalFormOptions.forEach((item) => {
                selected.push(item.value)
            })
            this.selected = selected
            this.setFilter()
        },

        setNone() {
            this.selected = []
            this.setFilter()
        },
    },

    computed: {
        ...mapState({
            filters: (state) => state.reportingVM.filters,
            filterOptions: (state) => state.data.options,
        }),

        legalFormOptions() {
            return this.filterOptions.legalForms.filter(
                (item) => item.value > 0
            )
        },
    },
}
</script>

<style scoped>
.force-secondary :hover {
    color: #343a40 !important;
    font-weight: 700;
}

.force-secondary {
    color: #343a40 !important;
    font-weight: 700;
}

.force-white :hover {
    color: #fff !important;
    font-weight: 100;
}

.force-white {
    color: #fff !important;
    font-weight: 100;
}
</style>
